import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import SignInPage from '@pages/Auth/SignInPage/SignInPage';
import ForgotPasswordPage from '@pages/Auth/ForgotPasswordPage/ForgotPasswordPage';
import CheckInboxPage from '@pages/Auth/CheckInboxPage/CheckInboxPage';
import ResetPasswordPage from '@pages/Auth/ResetPasswordPage/ResetPasswordPage';
import StudentLoginPage from '@pages/StudentPortal/StudentLoginPage/StudentLoginPage';

const authRoutes: RouteObject[] = [
    { path: '/admin/signin', element: <SignInPage /> },
    { path: '/admin/cohort', element: <Navigate to="/admin/signin" replace /> },
    { path: '/login', element: <StudentLoginPage /> },
    { path: '/sign-in', element: <Navigate to="/login" replace /> },
    { path: '/admin/forgot-password', element: <ForgotPasswordPage /> },
    { path: '/forgot-password', element: <Navigate to="/admin/forgot-password" replace /> },
    { path: '/admin/forgot-password/sent', element: <CheckInboxPage /> },
    { path: '/forgot-password/sent', element: <Navigate to="/admin/forgot-password/sent" replace /> },
    { path: '/admin/reset-password', element: <ResetPasswordPage /> },
    { path: '/reset-password', element: <Navigate to="/admin/reset-password" replace /> },
];

export default authRoutes;